import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { ICommissionTransaction } from "./partnerCommissions"

export const adminCommissions: IGenericModel<ICommissionTransaction> = {
    ...generic(endpoints.ADMIN_COMMISSIONS),
}
